import { BackActionTopBar } from '@ui-components/navigation/BackActionTopBar'
import { useIntl } from 'react-intl'

import { useGlobalServices } from '../../hooks'
import { getCancelWithoutSavingModalEvent } from '../Modal/CancelWithoutSavingModal'

export interface BackToSummaryTopBarProps {
  isEditing: boolean
  isFormDirty: boolean
  onBackConfirmed: () => void
}

export const BackToSummaryTopBar = ({ isEditing, isFormDirty, onBackConfirmed }: BackToSummaryTopBarProps) => {
  const intl = useIntl()
  const { openModal } = useGlobalServices()

  if (isEditing) {
    return undefined
  }

  const showDiscardChangesModal = () => {
    const continueAction = intl.formatMessage({ id: 'common-continue-anyway' })
    openModal(
      getCancelWithoutSavingModalEvent({
        onConfirm: () => {
          onBackConfirmed()
        },
        intl,
        header: intl.formatMessage({ id: 'common-back-to-application-unsaved-header' }),
        text: intl.formatMessage(
          { id: 'common-back-to-application-unsaved-warning' },
          { continue_action: continueAction },
        ),
        primaryActionText: continueAction,
      }).data,
    )
  }

  return (
    <BackActionTopBar
      backLabel={intl.formatMessage({ id: 'common-back-to-summary-action' })}
      onBackClick={() => {
        if (isFormDirty) {
          showDiscardChangesModal()
        } else {
          onBackConfirmed()
        }
      }}
    />
  )
}
